exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1vRBxVGX9Pg_eU7MLqnhJy._3BXbhd0FsQDLeqkBdbds9j,._1vRBxVGX9Pg_eU7MLqnhJy.-Pi4493YT6U2AYU6SL2U1{font-size:12px}._1vRBxVGX9Pg_eU7MLqnhJy._2HJGub1Z67anwpzTOz2c5q,._1vRBxVGX9Pg_eU7MLqnhJy.-Pi4493YT6U2AYU6SL2U1._1lDz8eVsK7oD1uTQIwZ7Z9{font-size:14px}.KoqQrhjuX3m4B8eSYGQZw._3BXbhd0FsQDLeqkBdbds9j,.KoqQrhjuX3m4B8eSYGQZw.-Pi4493YT6U2AYU6SL2U1{font-size:11px}.KoqQrhjuX3m4B8eSYGQZw._2HJGub1Z67anwpzTOz2c5q{font-size:12px}", ""]);
// Exports
exports.locals = {
	"messageListMajorTextNext": "_1vRBxVGX9Pg_eU7MLqnhJy",
	"compact": "_3BXbhd0FsQDLeqkBdbds9j",
	"medium": "-Pi4493YT6U2AYU6SL2U1",
	"full": "_2HJGub1Z67anwpzTOz2c5q",
	"firstLineText": "_1lDz8eVsK7oD1uTQIwZ7Z9",
	"messageListMinorTextNext": "KoqQrhjuX3m4B8eSYGQZw"
};